<template>
  <div v-if="isLoaded">
    <div class="modal" tabindex="-1" role="dialog" id="myModal" @keydown="handleKeyBoardShortcuts">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header p-2">
            <h5 class="modal-title">{{$t('Hype Share')}} : {{getTitleOfFile}}</h5>
            <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close" v-on:click="closeMetadataManager">
              <span aria-hidden="true">
                  <cancel-icon class="close-icon" data-toggle="modal" data-target="#myModal" style="height: 40px !important;
                      width: 40px !important;
                      color: #fff;">
                  </cancel-icon>
                </span>
            </button>
          </div>
          <div class="modal-body row">
            <div class="col-md-7 selected-thumbnail-display video_wrapper h-100 p-1 m-0" style="overflow-y:auto;">
                <div class="w-100" style="position:relative"> <!--height:350px;-->
                   <template v-if="isVideoFile">
                          <div>
                            <PlayerAndMarkinMarkoutWrapperComponent :category_id="assetDetails.category_id" :master_asset_id="getMasterAssetId" wrappercomponent="sub-clips-manager">
                              <template v-slot:videomarkinmarkout>
                                <video-player @controller="setController" ref="videoPlayerRef" :playerForwardBackward="playerSteps" :options="videoOptions" style="height:100%;width:100%"/>
                                <VideoMarkinMarkoutSlider v-on:steps="videoSteps" :playerDuration="playerDuration" v-if="playerDuration" :assetDetails="assetDetails"  class="markin-markout-slider" ref="sliderComponent" :markinMarkoutRef="$refs">
                                    <template v-slot:action_buttons>
                                        <MarkinMarkoutActions :sliderReference="$refs" :buttonNotRequiredList="['subclip']" ref="markinMarkoutActionRef" emitName="subclipPostResponse" emitPlayActiveRegionName="toggleActiveItemHighlight"  @toggleActiveItemHighlight="highlightActivePlayBox" @markinMarkoutPlayerListerner="setMarkinMarkoutPlayerListener" :clearMarker="clearMarker"/> 
                                    </template>
                                </VideoMarkinMarkoutSlider>
                              </template>
                            </PlayerAndMarkinMarkoutWrapperComponent>
                          </div>
                     </template>
                  <audio v-if="isAudioFile" id="audio-player-id" class="audio-player" controls="controls" controlslist="nodownload">
                      <source :src="audioUrl" type="audio/mpeg" />
                  </audio>
                  <!-- <embed v-if="!isVideoFile" src="http://www.pdf995.com/samples/pdf.pdf" alt="pdf" style="height:100%;width:100%" pluginspage="http://www.adobe.com/products/acrobat/readstep2.html"> -->
                  <img v-if="isImageFile" :src="getThumbnailPath(assetDetails)" @error="replaceByDefaultImage">
                </div>
                <div class="heightSet" v-if="this.assetDetails.mime_type.startsWith('video')">
                  <div class="thumbanils-display">
                    <div class="thumbnail-comm-wrapper">
                      <div class="generated-thumbails" ref="activeThumbnailDiv"  v-on:click="updateGeneratedThumbnail('thumbnailFromServer')" :class="{activeDiv: activeThumbnail === 'thumbnailFromServer'}">
                        <img :src="getProxyConvertedURL(thumbnailFromServerUrl)" @error="replaceByDefaultImage" style="height:100%;width:100%" class="unselected-image"/>
                      </div>
                      <div class="comm-thumbnail-btn-div">
                        <button class="btn btn-outline-secondary mr-3 comm-thumbnail-btn" disabled>Thumbnail 1</button>
                      </div>
                    </div>    
                    <div class="thumbnail-comm-wrapper">
                      <div class="generated-thumbails" v-on:click="updateGeneratedThumbnail('thumbnailFromServerTwo')" :class="{activeDiv: activeThumbnail === 'thumbnailFromServerTwo'}">
                        <img :src="getProxyConvertedURL(secondThumbnailFromServerUrl)" @error="replaceByDefaultImage" style="height:100%;width:100%" class="unselected-image"/>
                      </div>
                      <div class="comm-thumbnail-btn-div">
                        <button class="btn btn-outline-secondary mr-3 comm-thumbnail-btn" disabled>Thumbnail 2</button>
                      </div>
                    </div>
                    <div class="thumbnail-comm-wrapper">
                      <div class="custom-thumbanil" v-on:click="updateGeneratedThumbnail('uploadedThumbnail')" :class="{activeDiv: activeThumbnail === 'uploadedThumbnail'}">
                        <!-- <img v-if="isUploadedThumbnailUrl" @error="replaceByDefaultImage" :src="getProxyConvertedURL(thumbnailUrl)" ref="uploading_img" style="height:100%;width:100%" class="unselected-image"/> -->
                        <canvas id="upload_thumbnail_canvas" v-if="isUploadedThumbnailUrl" style="height:100%;width:100%" class="unselected-image"></canvas>
                        <div class="clear-captured-image" @click.stop.prevent="clearUploadedImage">  
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#fff" class="bi bi-x-lg" viewBox="0 0 16 16">
                            <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
                            <title>Remove Thumbnail</title>
                          </svg>
                        </div> 
                        <div class="d-inline-flex" v-if="!isUploadedThumbnailUrl && !canvasImg" style="padding-top: 15%;padding-inline-start: 13%;position:absolute;bottom:32%;inset-inline-end:10%">
                          <div style="padding:5px;margin-bottom:6px">
                            <!-- <svg xmlns="http://www.w3.org/2000/svg"  style="margin-inline-end:5px" width="16" height="16" fill="currentColor" class="bi bi-upload" viewBox="0 0 16 16">
                              <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"/>
                              <path d="M7.646 1.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 2.707V11.5a.5.5 0 0 1-1 0V2.707L5.354 4.854a.5.5 0 1 1-.708-.708l3-3z"/>
                            </svg> -->
                            <!-- <span class="secondary-btn-style">Upload Thumbnail</span> -->
                          </div>
                        </div>
                        <!-- <div v-if="!isUploadedThumbnailUrl && !canvasImg" style="position: absolute;top: 1%;inset-inline-start:0%;opacity: 0;height:100%;width:100%">
                            <input style="height:100%;width:100%" type="file" id="img" name="img" accept="image/*" ref="file" v-on:change="uploadThumbnail($event)"/>
                        </div> -->
                        <!-- <div v-if="isUploadedThumbnailUrl canvasImg|| canvasImg" v-on:click="isChange = !isChange" style="position:absolute;top:0px;inset-inline-end:0px" class="replace-uploaded-thumbnail">
                          <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" class="bi bi-three-dots-vertical" viewBox="0 0 16 16">
                            <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"/>
                          </svg>
                          <div v-if="isChange" class="change-thumbnail">Change
                            <div style="position: absolute;top: 1%;inset-inline-start:0%;opacity: 0;height:100%;width:100%">
                                  <input 
                                    style="height:100%;width:100%"
                                    type="file"
                                    id="img" name="img" accept="image/*"
                                    ref="file"
                                    v-on:change="uploadThumbnail($event)"
                                  />
                            </div>
                          </div>
                        </div>               -->
                      </div>
                      <div class="comm-thumbnail-btn-div">
                        <button @click="updateGeneratedThumbnail('uploadedThumbnail')" class="btn btn-outline-secondary mr-3 comm-thumbnail-btn" style="position:relative">Upload Thumbnail
                          <input style="height: 100%; width: 100%; opacity: 0;display: inline-block;position: absolute;inset-inline-end :0px;top: 0px;" type="file" id="img" name="img" accept="image/*" ref="file" v-on:change="uploadThumbnail($event)"/>
                        </button>
                      </div>  
                    </div>
                    <div class="thumbnail-comm-wrapper">
                      <div class="generated-thumbails"  v-on:click="updateGeneratedThumbnail('capturedThumbnailFromServer')" :class="{activeDiv: activeThumbnail === 'capturedThumbnailFromServer'}">
                        <img v-if="isCapturesThumbnailUrl" @error="replaceByDefaultImage" ref="captured_image" style="height:100%;width:100%" class="unselected-image"/>
                        <div class="clear-captured-image" @click="clearCapturedImage">  
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#fff" class="bi bi-x-lg" viewBox="0 0 16 16">
                            <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
                            <title>Remove Thumbnail</title>
                          </svg>
                        </div>  
                        <div class="d-inline-flex" v-if="!isCapturesThumbnailUrl" style="padding-top: 15%;padding-inline-start: 13%;position:absolute;bottom:32%;inset-inline-end:10%">
                          <div style="padding:5px;margin-bottom:6px">

                          </div>
                       </div>  
                      </div>
                         
                      <div class="comm-thumbnail-btn-div">
                        <button @click="updateGeneratedThumbnail('capturedThumbnailFromServer'),captureVideoCanvas()" class="btn btn-outline-secondary mr-3 comm-thumbnail-btn">Capture</button>
                      </div>
                    </div>   
                  </div>
                </div>
            </div>
            <div class="col-md-5 p-0 h-100 metadata-fields" style="overflow:auto">
              <div class="common-input-field" style="margin-inline-start: 2%;margin-top:7px;">
                  <label>Title<sup> *</sup></label>
                  <input type="text" v-model="slugName" ref="titileInputRef" placeholder="Enter title" class="bg-transparent rounded text-light input-text-field add-border"/>
              </div>
              <div class="common-input-field" style="margin-inline-start: 2%;margin-top:7px;">
                  <nav class="navbar navbar-expand-lg p-0">
                    <div class="collapse navbar-collapse" id="navbarNavAltMarkup" style="cursor: pointer;">
                      <div class="navbar-nav w-100 top-nav-bar" style="display: flex;justify-content: space-around;">
                        <a class="nav-item nav-link" @click="activeIndex = 'Generic Description'" :class="(activeIndex === 'Generic Description')?'active':'inactive'">{{$t('Generic Description')}}<span class="sr-only">(current)</span></a>
                        <a class="nav-item nav-link" @click="activeIndex = 'Facebook'" :class="(activeIndex === 'Facebook')?'active':'inactive'">{{$t('Facebook')}}<span class="sr-only">(current)</span></a>
                        <a class="nav-item nav-link" @click="activeIndex = 'Youtube'" :class="(activeIndex === 'Youtube')?'active':'inactive'">{{$t('Youtube')}}<span class="sr-only">(current)</span></a>
                        <a class="nav-item nav-link" @click="activeIndex = 'Twitter'" :class="(activeIndex === 'Twitter')?'active':'inactive'">{{$t('Twitter')}}<span class="sr-only">(current)</span></a>
                      </div>
                    </div>
                  </nav>
                  <button v-if="activeIndex != 'Generic Description'" style="text-align: end;width: inherit;margin-top: 15px;color:#aaa;margin-bottom:5px;font-size:13px" class="click-to-copy-button" @click="clickToCopyDescription()">Copy from generic</button>
                  <textarea v-if="activeIndex == 'Generic Description'" type="text" v-model="description" :placeholder="$t('Enter the description which applies to all social medias')" class="bg-transparent rounded text-light input-text-field add-border mt-3" style="height:150px;resize: none;padding-top: 6px;"></textarea>
                  <textarea v-if="activeIndex == 'Facebook'" type="text" v-model="facebookDescription" :placeholder="$t('Enter the description for facebook')" class="bg-transparent rounded text-light input-text-field add-border" style="height:150px;resize: none;padding-top: 6px;"></textarea>
                  <textarea v-if="activeIndex == 'Youtube'" type="text" v-model="youtubeDescription" :placeholder="$t('Enter the description for youtube')" class="bg-transparent rounded text-light input-text-field add-border" style="height:150px;resize: none;padding-top: 6px;"></textarea>
                  <textarea v-if="activeIndex == 'Twitter'" type="text" v-model="twitterDescription" :placeholder="$t('Enter the description for twitter')" class="bg-transparent rounded text-light input-text-field add-border" style="height:150px;resize: none;padding-top: 6px;"></textarea>
              </div>
              <div class="d-flex" style="justify-content: start;
          flex-wrap: wrap;margin:11px 7px;">
                <div class="view-tags-data add-tags" v-on:click="openTagsBrowseWindow()" style="border: 1px solid #696613 !important;
    margin-inline-start: 5px !important;">
                  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" class="bi bi-plus" viewBox="0 0 16 16">
                    <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
                  </svg>
                  {{$t('Add Tags')}}
                </div>  
                <li v-for="item in selectedTagsList" :key="item._id" class="view-tags-data">#{{item.name}}
                  <svg xmlns="http://www.w3.org/2000/svg" style="margin: -4px;
          margin-inline-start: 5px;" width="25" height="25" fill="#666" class="bi bi-x remove-tag" @click="removeTag(item)" viewBox="0 0 16 16">
                    <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                  </svg>
                </li>
              </div>
              <div v-if="!fileInfo.mime_type.startsWith('image')" class="common-input-field" style="margin-inline-start: 2%;margin-top:8px;align-items: center;">
                  <label>{{$t('Profile')}}</label>
                  <div class="profile-comm-style" style="display: block;flex:1;">
                      <Multiselect
                          :value="profileObj"
                          :options="profilesList"
                          label="profile_name"
                          
                          :placeholder="$t('Select Profile')"
                          :hideSelected="false"
                          :close-on-select="true"
                          deselectLabel=""
                          selectLabel=""
                          selectedLabel=""
                          :showNoOptions="false"
                          @select="selectProfile($event)"
                          @open="dropDownOpened"
                          ref="profilesDropdown"
                          >
                          <!-- <div style="display:flex;max-height:12px;align-items:center;" class="checkbox-label" slot="option" slot-scope="scope">
                            <span style="margin-inline-start:12px;">{{ scope.option.profile_name }}</span>
                          </div>
                          <span slot="noResult">No results.</span> -->
                      </Multiselect>
                  </div>
              </div>
              <div style="display:block;margin: 11px 4px">
                <div class="common-input-field" style="margin-inline-start: 2%;margin-top:8px;align-items: center;">
                  <label>{{$t('Social Media Handles')}}<sup> *</sup></label>
                  <div class="profile-comm-style" style="display: block;flex:1;">
                      <Multiselect
                          :value="selectedSocialMediaHandle"
                          :options="socialMediaHandlesArr"
                          label="profile_name"
                          
                          :placeholder="$t('Select social media handle')"
                          :hideSelected="false"
                          :close-on-select="true"
                          deselectLabel=""
                          selectLabel=""
                          selectedLabel=""
                          :showNoOptions="false"
                          @select="selectHandle($event)"
                          ref="HandlesDropdown"
                          >
                          <!-- <div style="display:flex;max-height:12px;align-items:center;" class="checkbox-label" slot="option" slot-scope="scope">
                            <span style="margin-inline-start:12px;">{{ scope.option.profile_name }}</span>
                          </div>
                          <span slot="noResult">No results.</span> -->
                      </Multiselect>
                  </div>
                  <div v-if="selectedSocialMediaHandle && selectedSocialMediaHandle.entities"  style="display:flex;flex-wrap:wrap">
                    <div v-for="entity in selectedSocialMediaHandle.entities" :key="entity.sm_profile_id" class='view-tags' style="width:auto;height: unset !important;">
                      <div  v-if="Object.keys(entity).includes('sm_profile_image') && !['undefined',null].includes(entity.sm_profile_image) && entity.sm_profile_image" class='user-name-or-image-in-profile'>
                        <img :src="getProxyConvertedURL(entity.sm_profile_image)" @error="replaceWithUserIcon($event)" style="height:100%;border-radius:6px;margin-bottom: 5px;object-fit:contain">
                        <div class="logo-display">
                          <img v-if="entity.social_media_type == 'facebook'" :src="facebookLogo" title="Facebook" @error="replaceWithUserIcon($event)" style="width:15px;height:15px;border-radius:6px;margin-bottom: 2px">
                          <img v-if="entity.social_media_type == 'youtube'" :src="youtubeLogo" title="Youtube" @error="replaceWithUserIcon($event)" style="width:15px;height:15px;border-radius:6px;margin-bottom: 2px">
                          <img v-if="entity.social_media_type == 'twitter'" :src="twitterLogo" title="Twitter" @error="replaceWithUserIcon($event)" style="width:15px;height:15px;border-radius:6px;margin-bottom: 2px">
                        </div>
                      </div>
                      <span>{{entity.sm_profile_name}}</span>
                    </div>
                  </div>
              </div>
                <!-- <div class="d-flex">
                  <div v-if="'enable_facebook' in hyPeConfigData &&  hyPeConfigData.enable_facebook" class="social-media" @click="facebookSelected = !facebookSelected" :class="facebookSelected?'active-social-media':''" data-name="facebook" :style="facebookSelected?'opacity:1;border:2px solid #1fa1f2':'opacity:0.4'">
                    <img :src="facebookLogo" style="height:40px;">
                    <span style="color: #6081c4;">Facebook</span>
                  </div>
                  <div v-if="this.fileInfo.mime_type.startsWith('video') && 'enable_youtube' in hyPeConfigData &&  hyPeConfigData.enable_youtube" class="social-media" @click="youtubeSelected = !youtubeSelected"  :class="youtubeSelected?'active-social-media':''" data-name="youtube" :style="youtubeSelected?'opacity:1;border:2px solid #1fa1f2':'opacity:0.4'">
                    <img :src="youtubeLogo" style="height:40px;">
                    <span style="color: #1fa1f2;">YouTube</span>
                   </div> 
                  <div v-if="'enable_twitter' in hyPeConfigData &&  hyPeConfigData.enable_twitter" class="social-media" @click="twitterSelected = !twitterSelected"   :class="twitterSelected?'active-social-media':''" data-name="twitter" :style="twitterSelected?'opacity:1;border:2px solid #1fa1f2':'opacity:0.4'">
                    <img :src="twitterLogo" style="height:40px;">
                    <span style="color: #1fa1f2;">Twitter</span>
                  </div> 
                </div>   -->
                <div v-if="checkIfSocialMediaExists('Youtube')" class="common-input-field" style="margin-inline-start: 2%;margin-top:8px;align-items: center;">
                  <label>{{$t('Youtube visibility')}}</label>
                  <div style="display: flex;justify-content: flex-start;padding-top: 10px;">
                    <div class="w-25" style="align-items: center;margin-bottom:15px;display: flex;align-items: baseline;">
                      <input type="radio" id="public" value="public" v-model="privacyStatus" class="bg-transparent border rounded text-light bigger-checkboxes" name="asset type" style="float:inline-start;flex:unset"/>
                      <label for="public" class="filter-label">{{$t('Public')}}</label>
                    </div>
                    <div class="w-25" style="align-items: center;margin-bottom:15px;display: flex;align-items: baseline;">
                      <input type="radio" id="private" value="private" v-model="privacyStatus" class="bg-transparent border rounded text-light bigger-checkboxes" name="asset type" style="float:inline-start;flex:unset"/>
                      <label for="private" class="filter-label">{{$t('Private')}}</label>
                    </div>
                    <div class="w-25" style="align-items: center;margin-bottom:15px;display: flex;align-items: baseline;">
                      <input type="radio" id="unlisted" value="unlisted" v-model="privacyStatus" class="bg-transparent border rounded text-light bigger-checkboxes" name="asset type" style="float:inline-start;flex:unset"/>
                      <label for="unlisted" class="filter-label">{{$t('Unlisted')}}</label>
                    </div>
                  </div>
              </div>               
            </div>
          </div>
          </div>
          <div class="modal-footer primary-btn-style">
            <button class="btn btn-outline-secondary mr-2" data-dismiss="modal"  v-on:click="closeMetadataManager()">{{$t('Cancel')}}</button>
            <button
            @click="shareToSocialMedia()"
            class="btn btn-outline-primary"
            data-v-198e7d7f=""
            style="position: relative; float: inline-end; inset-inline-end :0"
            >
            {{$t('Publish')}}
            </button>
        </div>
      </div>
    </div>
  </div>
  <tags-browse v-if="openTagsBrowse" :selectedTagsList="selectedTagsList" @allSelectedTags="allSelectedTags" @close="closeModal"></tags-browse>
</div>
</template>
<script>
import CancelIcon from "../core/InlineCancelField.vue";
import VideoPlayer from "../core/VideoPlayer.vue";
import "vue2-datepicker/index.css";
import {mapActions, mapGetters, mapMutations} from "vuex";
import Utils from "../../components.utils.js"
import VideoMarkinMarkoutSlider from '../core/VideoMarkinMarkoutSlider.vue';
import RangeSliderMixins from '../../mixins/RangeSliderMixin.js';
import MarkinMarkoutActions from '../markinMarkout/MarkinMarkoutActions.vue';
import PlayerAndMarkinMarkoutWrapperComponent from '../markinMarkout/PlayerAndMarkinMarkoutWrapperComponent.vue';
import {NotifierConstants} from "../../components.constants.js";
import Constants from "../../components.constants.js";
import tags from "./trendingTags.vue";
import Multiselect from 'vue-multiselect';
// import commentsVue from '../PAM/comments.vue';

export default {
  mixins:[RangeSliderMixins],
  name:'edit-and-share-manager',
  props:["fileInfo"],
  data() {
    return {
      selectedTagsList:[],
      postTitle:'',
      description:'',
      profilesList:[],
      // profileObj:{'sm_profile_name':'Original File','_id':'OriginalFile'},
      profileObj:null,
      clearMarker:false,
      isLoaded:false,
      assetId:null,
      assetDetails:{},
      assetDetailsOfSubclip:{},
      subclipsList:[],
      slugName: "",
      route:"",
      editingMetadataKeyInDock:null,
      assetCustomMetadata : {"custom_metadata":[]},
      categoryDetails:{name:"",id:""},
      categoryName:"",
      actionsOnPlayer: false,
      editMetadata:false,
      audioUrl:null,
      controller:{},
      videoOptions: {
          autoplay: false,
          controls: true,
          nativeTextTracks: true,
          controlBar:{
                'pictureInPictureToggle': false,
                'progressControl': false,
                'remainingTimeDisplay': false,

            volumePanel: {
                inline: false,
                vertical: true
            },

            playToggle: false
        },
        preload: "metadata", //loadmetadata such as duration required for range slider, won't load whole video
				sources: []
			},
      noDataFoundImage:Utils.getNoDataFoundImg(),
      selectedAssetId:null,
      page:1,
      totalSubclipsPages:-1,
      parentRouteInfo:{},
      fileId:null,
      facebookSelected:false,
      twitterSelected:false,
      youtubeSelected:false,
      facebookLogo: Constants.facebookLogo,
      twitterLogo: Constants.twitterLogo,
      youtubeLogo: Constants.youtubeLogo1,
      openTagsBrowse:false,
      thumbnailFromServerUrl:"",
      secondThumbnailFromServerUrl:"",
      selectedConvasImage:"",
      isUploadedThumbnailUrl:false,
      uploadedthumbnailUrl:"",
      canvasImg:false,
      uploadedCustomThumbnail:"",
      activeThumbnail:"thumbnailFromServer",
      isChange:false,
      isCapturesThumbnailUrl:false,
      capturedImageThumbnail:"",
      PROFILE_IMAGE_ALLOWED_WIDTH:128,
      hyPeConfigData:{},
      twitterDeciptionLengthLimit:280,
      twitterDurationLimit:140000,
      privacyStatus:'public',
      activeIndex:'Generic Description',
      facebookDescription:'',
      youtubeDescription:'',
      twitterDescription:'',
      socialMediaHandlesArr:[],
      selectedSocialMediaHandle:[],
    };
  },
  components:{
    "cancel-icon": CancelIcon,
    VideoPlayer: VideoPlayer,
    VideoMarkinMarkoutSlider,
    MarkinMarkoutActions,
    PlayerAndMarkinMarkoutWrapperComponent,
    "tags-browse": tags,
    Multiselect
  },
  computed:{
     getMasterAssetId(){
        if('asset_id' in this.assetDetails){
          return this.assetDetails.asset_id;
        }else{
          return this.assetDetails._id;
        }
      },
    isAudioFile(){
        try {
            return this.assetDetails.mime_type.startsWith("audio")   
            
        } catch (err) {
            console.error(`[isAudioFile][files][Error while checking filetype-${err}]`)
        }
        return false
    },
    isVideoFile(){
        try {
            return this.assetDetails.mime_type.startsWith("video")   
        } catch (err) {
            console.error(`[isVideoFile][files][Error while checking filetype-${err}]`)
        }
        return false
    },
    isImageFile(){

        try {
            return this.assetDetails.mime_type.startsWith("image")  ||  this.assetDetails.mime_type.startsWith("audio")   || this.assetDetails.mime_type.startsWith("doc")
        } catch (err) {
            console.error(`[isImageFile][files][Error while checking filetype-${err}]`)
        }
        return false
    },
    selectedAssetInfo(){
      return {assetDetailsFromParent:this.assetDetailsOfSubclip}
    },
    getTitleOfFile(){
      if(this.assetDetails.slug_name){
        return this.assetDetails.slug_name;
      }else{
        return this.assetDetails.file_name;
      }
    },
...mapGetters("users",["getLoggedInUserPrivilege","getLoggedInUserId"])
  },

  // mounted(){
  //      this.getTranscoderProfilesFromServer().then(profilesObj => {
  //          this.profilesList = profilesObj.profiles;
  //        console.log("BBBBBBBBBBBBBBBBBB", this.profilesList)
  //      });
       
  //     //  if(sessionStorage.getItem('media-edit-profile') != null){
  //     //      this.profileObj = JSON.parse(sessionStorage.getItem('media-edit-profile'));
  //     //  }
  // },
       
  methods: {
    checkIfSocialMediaExists(type){
      if(this.selectedSocialMediaHandle && this.selectedSocialMediaHandle.entities){
        for(let i = 0; i < this.selectedSocialMediaHandle.entities.length; i++){
          if(this.selectedSocialMediaHandle.entities[i].social_media_type && this.selectedSocialMediaHandle.entities[i].social_media_type.toLowerCase() == type.toLowerCase()){
            return true;
          }
        }
      }
      return false;
    },
    clickToCopyDescription(){
      if(this.activeIndex == 'Facebook'){
        this.facebookDescription = this.facebookDescription + this.description;
      }
      if(this.activeIndex == 'Youtube'){
        this.youtubeDescription = this.youtubeDescription + this.description;
      }
      if(this.activeIndex == 'Twitter'){
        this.twitterDescription = this.twitterDescription + this.description;
      }
    },
    replaceByDefaultImage(e){
            e.target.onerror = null
            e.target.src = Utils.getNoThumbnailImg();
        },
    setCaptureFrameInfo(clip){
        this.markinMarkoutThumbnailObj.show = true;
        this.markinMarkoutThumbnailObj.filename = clip.slug_name;
        this.markinMarkoutThumbnailObj.dur = clip.markers.start + ' - '+ clip.markers.end;
        this.markinMarkoutThumbnailObj.thumbnail = Utils.convertToLoginIPDomainName(clip.markers.frame_thumbnail_uri);
        this.markinMarkoutThumbnailObj.capture = false;
    },
    setController(controller){
          this.controller = controller
    },
    showActionsOnPlayer(){
        this.actionsOnPlayer = ! this.actionsOnPlayer;
    },
    maximisePlayer(){
        this.$emit("maximisePlayer");
    },
    closeMiniPlayer(){
        this.$emit("closeMiniPlayer")
    },
    getThumbnailPath(file){
      return Utils.getThumbnailPathfromFileInfo(file)
    },
    getLowresPath(file){
      return Utils.getLowresPathfromFileInfo(file)
    },
    getAudiowaveform(file){
        return Utils.getAudiowaveformFromFileInfo(file)
    },
    getUnique(array){
    var uniqueArray = [];
    
    // Loop through array values
    for(let i=0; i < array.length; i++){
        if(uniqueArray.indexOf(array[i]) === -1) {
            uniqueArray.push(array[i]);
        }
    }
    return uniqueArray;
    },
    closeModal(){
      this.openTagsBrowse = false;
    },
    openTagsBrowseWindow(){
      this.openTagsBrowse = true;
    },
    closeMetadataManager(){
      this.$emit("close");
    },
    humaniseSize(bytes){
        let data = Utils.humanizeSize(bytes)
        return `${data["value"]} ${data["unit"]}`
    },
    selectCategoryforAnAsset(){
        this.$emit("selectCategoryFromBrowse");
        this.cancelMetadataDockFields()
    },
    highlightActivePlayBox(isplaying){
      console.log('isplaying',isplaying);
    },
    getTrendingTags(){
        this.getTagsAutocompleteFromServer().then((data) => {
          this.$nextTick(()=>{
            this.trendingTagsArray = data["tags"];
          })
        });
    },

    getEnabledSocialMediaOptions(){
      this.getEnabledSocialMediaOptionsFromServerFromServer().then((data) => {
        this.$nextTick(()=>{
        this.hyPeConfigData = data;
        });
      });
    },
    allSelectedTags(tags){
      this.openTagsBrowse = false;
      this.selectedTagsList = tags;
    },
    getOnlyTagNames(tags){
      let tempList = [];
      for(let t = 0;t < tags.length; t++){
        tempList.push(tags[t].name);
      }
      return tempList;
    },
    removeTag(item){
      this.selectedTagsList = this.selectedTagsList.filter(e => e._id != item._id)
    },
    tagsLabelCallback(option){
        return `${option.name}`
    },

    getProfilesList(){
      // this.getTranscoderProfilesFromServer().then(profilesObj => {
        this.getHypeProfilesFromServer().then(profilesObj => {
        this.profilesList = profilesObj.profiles;
        // this.profilesList.unshift({'profile_name':'Original File','_id':'OriginalFile'});
      });
    },
    selectProfile(selectedProfile){
      this.profileObj = selectedProfile;
    },  
    selectHandle(selectedHandle){
      this.selectedSocialMediaHandle = selectedHandle;
    },
    dropDownOpened(){
/*           console.log('sssssss',this.$refs.profilesDropdown.$el.querySelector('.multiselect__input'));
          let inputWidth = this.$refs.profilesDropdown.$el.querySelector('.multiselect__input').width; */
          if(this.$refs.profilesDropdown.$el.querySelector('.multiselect__content-wrapper') && this.$refs.generalTab){
            this.$refs.profilesDropdown.$el.querySelector('.multiselect__content-wrapper').style.setProperty('width',`${this.$refs.generalTab.offsetWidth - 40}px`,'important'); 
          }  
         /*  this.$refs.generalTab.offsetWidth; */
       },

    async getThumbnails(){
      this.thumbnailFromServerUrl = Utils.convertToLoginIPDomainName(this.assetDetails.proxy_info.thumbnail_uri);
    //  let storyboardList = await this.getStoryboardList( {url:this.assetDetails.proxy_info.storyboard_uri});
      let storyboardList = [];
      this.getStoryboardFromServer(this.assetDetails.proxy_info.storyboard_uri).then((data)=>{
        storyboardList = data;
        if(storyboardList.length != 0){
          this.secondThumbnailFromServerUrl = `${decodeURIComponent(this.assetDetails.proxy_info.storyboard_uri)}/${decodeURIComponent(storyboardList[parseInt(storyboardList.length/2)]["name"])}`;
        }
      });
      
    },   

    uploadThumbnail(e){
      // this.selectedConvasImage = "";
      this.isUploadedThumbnailUrl = true;
      this.canvasImg = false;
      // const file = e.target.files[0];
      // this.encodeImgtoBase64(file);
      // this.thumbnailUrl = URL.createObjectURL(file);
      // if(this.$refs.uploading_img)this.$refs.uploading_img.setAttribute("src", this.thumbnailUrl)
      let file = e.target.files[0]; // get the file
      // this.encodeImgtoBase64(file)
      let blobURL = URL.createObjectURL(file);
      this.drawImage(blobURL)
    },

     drawImage(blobURL){
          // this.imageType = "canvas";
          let img = new Image();
          img.src = blobURL;
          img.onerror = ()=> {
              URL.revokeObjectURL(this.src);
              // Handle the failure properly
              console.log("Cannot load image");
          };
          img.onload = ()=> {
              URL.revokeObjectURL(this.src);
              let wrh = img.naturalWidth / img.naturalHeight;
              let calculatedImageHeightAsPerAspectRatio = this.PROFILE_IMAGE_ALLOWED_WIDTH / wrh;
              let canvas = document.getElementById("upload_thumbnail_canvas");
              console.log("SSSS",canvas)
              canvas.width = this.PROFILE_IMAGE_ALLOWED_WIDTH;
              canvas.height = calculatedImageHeightAsPerAspectRatio
              
              this.$nextTick(()=>{
                    console.log(canvas);
              canvas.getContext("2d").drawImage(img, 0, 0, this.PROFILE_IMAGE_ALLOWED_WIDTH, calculatedImageHeightAsPerAspectRatio);
              
              
                // console.log(canvas.toDataURL());
                  this.uploadedthumbnailUrl = canvas.toDataURL();
                //   this.$nextTick(() => {
                //       // if(!dontPost)this.updateProjectLogo(imageContext, projectId)
                //       if(document.getElementById("logo_default_"+projectId))document.getElementById("logo_default_"+projectId).style.display = "none";
                //       if(document.getElementById("logo_img_"+projectId))document.getElementById("logo_img_"+projectId).style.display = "none";
                //       document.getElementById("logo_"+projectId).style.display = "inline-block"
                //   });
              });

          
          };
      }, 


    // encodeImgtoBase64(img) {
    //   var reader = new FileReader();
    //   reader.onloadend = () => {
    //     this.uploadedCustomThumbnail = reader.result;
    //     console.log("PPPPPPPPPPPPPPPPPPPPPPPPPP", uploadedCustomThumbnail)
    //     this.selectedConvasImage = "";
    //     // this.customThumbnailUploadCheckboxAction("uploadedThumbnail")
    //   }
    //   reader.readAsDataURL(img);
    // },

    // customThumbnailUploadCheckboxAction(type){
    //   this.activeThumbnail = type;
    //   let payload = {};
    //   payload["file_uid"]= this.selectedFile.fileUID;
    //   if(type=="uploadedThumbnail"){
    //     if(this.selectedConvasImage.length){
    //       payload.data = {cust_thumb: this.selectedConvasImage};
    //     }else if(this.uploadedCustomThumbnail.length){
    //       payload.data = {cust_thumb: this.uploadedCustomThumbnail};
    //     }
    //     payload.data.path = this.selectedFile.path;
    //     this.attachUploadedOrCapturedThumbnailToFile(payload)
    //   }else if(type=="thumbnailFromServer"){
    //     payload.data = {cust_thumb: this.thumbnailFromServerUrl};
    //     payload.data.path = this.selectedFile.path
    //     this.attachSelectedThumbnailToFile(payload);
    //   }else if(type=="thumbnailFromServerTwo"){
    //     payload.data = {cust_thumb: this.secondThumbnailFromServerUrl};
    //     payload.data.path = this.selectedFile.path;
    //     this.attachSelectedThumbnailToFile(payload);
    //   }else if(type=="capturedThumbnailFromServer"){
    //     payload.data = {cust_thumb: this.$refs.captured_image.getAttribute('src')};
    //     payload.data.path = this.selectedFile.path;
    //     this.attachSelectedThumbnailToFile(payload);
    //   }
    // },

    updateGeneratedThumbnail(thumbnailType){
      this.activeThumbnail = thumbnailType;
      // this.customThumbnailUploadCheckboxAction(thumbnailType);
    },

    captureVideoCanvas(){
      this.$nextTick(() => {
        this.isCapturesThumbnailUrl = true;
        var canvas = document.createElement('canvas');
        var ctx = canvas.getContext("2d");
        var video = parent.document.querySelector('video#videoJSPlayer, #videoJSPlayer video');

        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
      
        let videoWrapperEl = parent.document.querySelector('.video_wrapper');

        console.log("DDDDDDDDDDDDDDD", videoWrapperEl.clientWidth)
        // this.options.cssMaxWidth = videoWrapperEl.clientWidth;
        // this.options.cssMaxHeight = videoWrapperEl.clientHeight - 150;

        let image = new Image();
        image.onload = () =>{
            let canvas2_ = document.createElement('canvas');
            canvas2_.crossOrigin = 'anonymous';
            let wrh =  image.width / image.height;
            let newWidth = video.clientWidth;
            let newHeight = newWidth / wrh;
            if (newHeight > video.clientHeight) {
                newHeight = video.clientHeight;
                newWidth = newHeight * wrh;
                newHeight = newHeight - 25;
            }
            console.log('newWidth:',newWidth,'newHeight:',newHeight);

            canvas2_.style.height = newHeight+"px";
            canvas2_.width = newWidth;
            canvas2_.height = newHeight;

            canvas2_.getContext("2d").drawImage(image, 0, 0, newWidth , newHeight);
            let url = canvas2_.toDataURL('image/jpg');
            // your image i url;
            this.$refs.captured_image.setAttribute('src', url);
            this.capturedImageThumbnail = url;
        }

        ctx.drawImage(video, 0, 0);
        let url = canvas.toDataURL('image/png');
        image.src = url;
      });
    },

    replaceWithUserIcon(e){
        e.target.onerror = null
        e.target.src = Utils.getNoThumbnailImg();
    },

    clearUploadedImage(){
      // this.$refs.uploading_img.removeAttribute('src');
      this.isUploadedThumbnailUrl = false;
    },

    clearCapturedImage(){
      this.$refs.captured_image.removeAttribute('src');
      this.isCapturesThumbnailUrl = false;
    },

    shareToSocialMedia(){
        let startEndtimeObj = {};
        if(this.$refs.sliderComponent){
          startEndtimeObj = this.$refs.sliderComponent.getStartEndTime();
        }  
        console.log("LLLLLLLLLLLLLLLLLLLLLLll", this.assetDetails)
        let payload = {};
        payload["job_name"] = "Hype-SocialMedia";
        payload["element_type"] = "file";
        if(this.youtubeSelected)payload["privacy_status"] = this.privacyStatus;
        let assetsList = [];
        assetsList.push({"asset_id":this.assetDetails.asset_id, "path":this.assetDetails.path});
        if(assetsList.length>0)payload["assets"] = assetsList;
        // payload["path"] = this.assetDetails.path;
        // payload["file_uid"] = this.assetDetails.file_uid;
        payload["tags"] = this.getOnlyTagNames(this.selectedTagsList);

        
        let inoutObj = {};
        if(Object.keys(startEndtimeObj).length>0 && this.fileInfo.mime_type.startsWith('video')){
          if((startEndtimeObj.start != 0 || startEndtimeObj.end != (this.controller.player.duration()*1000)) || ('profile_id' in  payload && payload['profile_id'] != "OriginalFile")){
            inoutObj.mark_in = startEndtimeObj.start;
            inoutObj.mark_out = startEndtimeObj.end;
          }  
        }  
        if(Object.keys(inoutObj).length>0){
          payload["in_outs"] = inoutObj;
        }

        if(!this.assetDetails.mime_type.startsWith("image") && this.profileObj && Object.keys(this.profileObj).length>0){
        //     if(Object.keys(inoutObj).length>0 && this.profileObj._id == "OriginalFile"){
        //       alert("Profile 'Original File' is not allowed for trimmed video");
        //       return false;
        //     }else{
              payload["profile_id"] = this.profileObj._id;
        //     }
        }

        if(this.slugName.length){
          if(this.checkIfSocialMediaExists("Youtube") && this.slugName.length > 100){
            alert("Youtube has a limit of 100 characters for the title, provide title less than 100 characters");
          return false;
          }
          payload["title"] = this.slugName;
        }else{
          alert("Title is empty");
          return false;
        }
        if(this.description.length == 0 ){
          if(this.checkIfSocialMediaExists("Facebook") && this.facebookDescription.length == 0){
            alert("Facebook description is empty, Either provide generic description or facebook specific description");
            return false;
          }
          if(this.checkIfSocialMediaExists("Youtube") && this.youtubeDescription.length == 0){
            alert("Youtube description is empty, Either provide generic description or youtube specific description");
            return false;
          }
          if(this.checkIfSocialMediaExists("Twitter") && this.twitterDescription.length == 0){
            alert("Twitter description is empty, Either provide generic description or twitter specific description");
            return false;
          }
        }

        payload["description"] = this.description; 
        payload["specific_description"] = {"facebook":this.facebookDescription, "twitter":this.twitterDescription, "youtube":this.youtubeDescription}; 


        if(!this.selectedSocialMediaHandle || this.selectedSocialMediaHandle.length == 0){
          alert("Please selected Social Media handle");
          return false;
        }else{
          payload['send_to'] = this.selectedSocialMediaHandle._id;
        }

        if(this.checkIfSocialMediaExists("Twitter")){
          if(this.controller.player){
              let totalPlayerDuration = this.controller.player.duration()*1000;
              if((totalPlayerDuration > this.twitterDurationLimit && (startEndtimeObj.end - startEndtimeObj.start > this.twitterDurationLimit))){
                alert("Prease trim the video, Twitter will not allow to publish the video which is having more than 2 minutes 20 seconds of duration");
                return false;
              }
            }  
          if((this.twitterDescription > 0 && (this.twitterDescription > this.twitterDeciptionLengthLimit)) || (this.description.length > this.twitterDeciptionLengthLimit)){
            alert("Twitter will allow only 280 characters of Description");
            return false;
          }
        }
      
        // let send_to_list = [];
        // [].map.call(document.querySelectorAll('.active-social-media'),function(el){
        //     if(!send_to_list.includes(el.getAttribute("data-name"))) send_to_list.push(el.getAttribute("data-name"))
        // });

        // // if(this.facebookSelected && this.twitterSelected)payload["send_to"] = ["facebook","twitter"];
        // // if(this.facebookSelected && !this.twitterSelected)payload["send_to"] = ["facebook"];
        // // if(!this.facebookSelected && this.twitterSelected)payload["send_to"] = ["twitter"];
        // // if(!this.facebookSelected && !this.twitterSelected){
          
        // if(send_to_list.length == 0){ 
        //   alert("Select social media to post");
        //   return false;
        // }else{
        //   if(send_to_list.includes('twitter')){
        //     if(this.controller.player){
        //       let totalPlayerDuration = this.controller.player.duration()*1000;
        //       if((totalPlayerDuration > this.twitterDurationLimit && (startEndtimeObj.end - startEndtimeObj.start > this.twitterDurationLimit))){
        //         alert("Prease trim the video, Twitter will not allow to publish the video which is having more than 2 minutes 20 seconds of duration");
        //         return false;
        //       }
        //     }  
        //   }
        //   payload["send_to"] = send_to_list;
        // }

        // // payload["custom_thumb"] = {"use":false};

        // if(this.description.length){
        //   if(send_to_list.includes('twitter')){
        //     if(this.description.length > this.twitterDeciptionLengthLimit){
        //       alert("Twitter will allow only 280 characters of Description");
        //       return false;
        //     }            
        //   }
          

        //   payload["description"] = this.description; 
        // }else{
        //   alert("Description is empty");
        //   return false;
        // }

        let thumnailObj = {};
        let selectedThumbnailType = this.activeThumbnail;
        if(selectedThumbnailType == "thumbnailFromServer" && this.thumbnailFromServerUrl){
          thumnailObj["type"] = "frame_path";
          thumnailObj["value"] = this.thumbnailFromServerUrl;
        } 
        
        if(selectedThumbnailType == "thumbnailFromServerTwo" && this.secondThumbnailFromServerUrl){
          thumnailObj["type"] = "frame_path";
          thumnailObj["value"] = this.secondThumbnailFromServerUrl;
        }

        if(selectedThumbnailType == "uploadedThumbnail"){
          thumnailObj["type"] = "upload_thumbnail";
          if(this.uploadedthumbnailUrl){
            thumnailObj["value"] = this.uploadedthumbnailUrl;
          }else{
            alert("Please Upload thumbnail Image");
            return false;
          }
        }

        if(selectedThumbnailType == "capturedThumbnailFromServer"){
          thumnailObj["type"] = "capture";
          thumnailObj["value"] = this.controller.player.currentTime() * 1000;
        }

        if(Object.keys(thumnailObj).length>0){
          payload["custom_thumbnail"] = thumnailObj;
        }

        console.log("ZZZZZZZZZZZZZZZZZZZZZZZ", payload);

        this.socialMediaShareJob(payload).then((data) => {
          console.log("TTTTTTTTTTTTTTTTT>>>>>>>>>>>>", data.status)
          if (Utils.isAcceptedStatusCode(data.status)) {
              this.$toast.success("Publish to social media initiated");
              this.closeMetadataManager();
          }else{
              this.$toast.error("Faild to publish");
          }
        });
      },
    handleFileUpdateNotification(notification){
      notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
      if(notification.message){
        let path = notification.message.path
        let parent_path = notification.message.parent_path;
        if (this.assetDetails.path == path){
            if (this.assetDetails.mime_type.startsWith("video")){
                Object.assign(this.assetDetails, notification.message)
                this.videoOptions.autoplay=false;
                this.videoOptions.sources = [{
                        src:this.getLowresPath(notification.message),
                        type: "video/mp4",
                    }]
                if (  this.controller.player){
                    this.controller.restartPlayer(this.videoOptions.sources[0]);
                }
            }else if (this.assetDetails.mime_type.startsWith("audio")){
                this.audioUrl = this.getAudiowaveform(this.assetDetails)
            }else if (this.assetDetails.mime_type.startsWith("image")){
                Object.assign(this.assetDetails, notification.message)
            }
            console.log(`[handleFileUpdateNotification][AssetDetails][File(${path}) updated in path->${parent_path}]`)
        }
        }
    },
    getSocialMediaHandles(){
      this.getSocialMediaProfiles().then((data) => {
        this.socialMediaHandlesArr = data.profiles;
      })
    },
    handleKeyBoardShortcuts(event){
        let keyCode = event.keyCode || event.which;
        console.log(keyCode,event);
        let pressedElement = String(event.target.nodeName).toLowerCase();
        if(pressedElement == 'input' || pressedElement == 'textarea' || pressedElement == 'select' ) return true;
        console.log('execute keycode');

        if(keyCode === 73){ // 'i' key for markin
             this.$refs.markinMarkoutActionRef.markin();
        } 

        if(keyCode === 79){ // 'o' key for markout
             this.$refs.markinMarkoutActionRef.markout();
        } 
     
        if(keyCode === 80){ // 'p' key for preview markin,markout region [video]
              this.$refs.markinMarkoutActionRef.playMarkinMarkoutPreview();
        } 

        if(keyCode === 32){ // 'spacebar' key for toggle play->pause
            this.$refs.markinMarkoutActionRef.playPauseToggle();
        } 

        if(keyCode === 57){ // '9' key for backward video by 1sec
             this.$refs.markinMarkoutActionRef.forwardBackwardVideoBy1Sec('backward');
        } 

        if(keyCode === 48){ // '0' key for forward video by 1sec
           this.$refs.markinMarkoutActionRef.forwardBackwardVideoBy1Sec('forward'); 
        } 

        if(keyCode === 189){ // '-' key for backward video by 1 frame
            this.$refs.markinMarkoutActionRef.forwardBackwardVideoByFrame('backward');
        }

        if(keyCode === 187){ // '=' key for forward video by 1 frame
             this.$refs.markinMarkoutActionRef.forwardBackwardVideoByFrame('forward');
        }

        if(keyCode === 67){ // 'c' key for clearing markin,markout region
            this.$refs.markinMarkoutActionRef.resetMarkinMarkoutSlider();
        }

        if(keyCode === 70){ // 'f' key for clearing markin,markout region
            this.$refs.markinMarkoutActionRef.captureFrame();
        }

    },
    registerforWebsocketNotifications(){
      this.addWSEventListener({eventname:NotifierConstants.fileModifiedNotification, callback:this.handleFileUpdateNotification,parent:"subclips"})
    },
    unRegisterforWebsocketNotifications(){
      this.removeWSEventListener({eventname:NotifierConstants.fileModifiedNotification, callback:this.handleFileUpdateNotification,parent:"subclips"})
    },
    ...mapActions("files", ["getFileInfoFromServer", "getStoryboardList"]),
    ...mapActions("hype", ["socialMediaShareJob","getTagsAutocompleteFromServer", "getEnabledSocialMediaOptionsFromServerFromServer", "getHypeProfilesFromServer","getSocialMediaProfiles"]),
    ...mapActions("assets", ["getAssetInfoFromServer"]),
    ...mapActions('transcoder',['getTranscoderProfilesFromServer']),
    ...mapActions('proxy',['getStoryboardFromServer']),
    ...mapMutations("websocket",["addWSEventListener", "removeWSEventListener"])
  },
  beforeDestroy(){
    this.unRegisterforWebsocketNotifications()
  },
  created(){
    this.isLoaded=false;
    this.assetDetails = {}

    this.getProfilesList();
    this.getSocialMediaHandles();
    this.getEnabledSocialMediaOptions();
    Object.assign(this.assetDetails, this.fileInfo)
    this.slugName = `${this.assetDetails.slug_name}`
    if (this.assetDetails.mime_type != undefined && this.assetDetails.mime_type.startsWith("video")){
        this.videoOptions.sources.push({
              src:this.getLowresPath(this.assetDetails),
              type: "video/mp4"
          })
          
          this.getThumbnails();
    }else if (this.assetDetails.mime_type != undefined && this.assetDetails.mime_type.startsWith("audio")){
      this.audioUrl = this.getAudiowaveform(this.assetDetails)
    }
    this.isLoaded=true;
    this.getTrendingTags();
    this.registerforWebsocketNotifications()
    },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped lang="scss">
$border-color: 1px solid #4a4a4a;
$border-color-only:#4a4a4a;
$primary-background: #1a1e21;
$secondary-background-color:#15181B;
$bg-color-on-hover: #22272b;
$text-color: #eee;
$dull-text-color: #757575;
$secondary-text-color: #9c9c9c;
$active-blue : #007bff;
$input-field-and-label-font-size:14px;
$input-field-height:38px;
$none-text-color:#4f4f4f;
$input-field-padding:.375rem 10px;
$scrollbar-thumb-background:#333;
$scrollbar-track-background:#1a1e21;
$scrollbar-thumb-on-hover-background:#555;
$tags-background-color:#282d31;
$tags-border-color:#363636;
$secondary-border-color: 1px solid #2b2b2b;
$metadata-border-color-on-hover: #5a5a5a;
$add-button-text-color:#0b7099;
$add-button-text-color-hover:#0193cc;
$add-button-border-color:#696613;
$add-button-border-on-hover:#dcd426;
$add-button-backgroud:#1e1e1e;
$icon-hover:#2c3339;

.li-style-change{
  background: $metadata-border-color-on-hover !important;
}

.selectedSubclipRow{
  border: 2px solid $active-blue !important;
}
.breadcrumb{
  padding: 0px !important;
  background: #181818 !important;
  li{
    position:relative;
    top:8px;
  }
    .active-text-nav-bar{
        color: $text-color !important;
        text-decoration: none !important
    }
    .active-text-nav-bar:last-child{
            color: $active-blue !important;
            font-size:17px;
    }
    .breadcrumb-item{
        a{
            color: $text-color;
            font-weight:600;
        }
        a:hover{
            text-decoration: underline;
        }
    }    
}

.readonlyDiv{
  background: #15181b;
}

.readonly-field{
  color:$text-color;
}

.modal-dialog {
    width: 100vw;
    height: 100vh;
    max-width:100%;
    margin: 0;
    padding: 0;
  }
 
  .modal-content {
    height: auto;
    min-height: 100%;
    border: 0 none;
    border-radius: 0;
    box-shadow: none;
    background: $primary-background !important;
    border: $secondary-background-color;
    .modal-body{
      background: $primary-background;
      overflow:auto;
      height:300px;
      padding: 0px 0px 0px 0px;
      display:inline-flex;
      width:100%;
    }
  }

.modal {
  text-align: center;
  padding: 0!important;
  display:block;
}
.modal:before {
  content: '';
  display: inline-block;
  height: 100%;
  vertical-align: middle;
  margin-inline-end: -4px;
}
.modal-dialog {
  display: inline-block;
  text-align: start;
  vertical-align: middle;
}

.btn{
    font-size:14px !important;
    height:100%;
}

.activeDiv{
  border:6px solid $active-blue !important;
  border-radius: 5px;
  img,canvas{
    opacity:1;
  }
}

/* width */
  ::-webkit-scrollbar {
    width: 8px;
    height:8px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: $secondary-background-color !important;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: $primary-background !important;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: $bg-color-on-hover !important;
  }

.border{
    border: $border-color !important;
}

.activeclass{
    color: $active-blue;
}

.row{
  margin:-12px !important;
  margin-inline-start:0px !important;
}

.metadata-fields{
  background: $primary-background;
  border-inline-start: $secondary-border-color !important;
}


.modal-header,.modal-footer{
    border-top: $secondary-border-color !important;
    border-bottom: $secondary-border-color !important;
    background: $secondary-background-color !important;
    align-items: unset;
    .modal-title{
      color:$text-color;
      padding:3px;
    }
}

.modal-header .close {
    // margin: -1rem -19px -0rem auto !important;
     margin:0px !important;
    padding: 0px !important;
}

ul{
    list-style-type: none;
}

.modal-footer{
    justify-content: start;
}


.activeTag{
    color: $active-blue !important;
}

.editIcon {
  margin-inline-start: 9px;
  position: absolute;
    inset-inline-end: 7%;
    top: 45%;
}

.aboutField{
  margin-inline-start: 9px;
  position: absolute;
    inset-inline-end: 1%;
    top: 45%;
}
.input-fields {
  border: none !important;
  min-width: 250Px;
  border-bottom: 1px solid $active-blue !important;
  padding-inline-start:5px;
  padding-top: 3px;
  height:38px;
}

.svg-icon:hover{
  fill:#eee;
}

.text-light{
  color: #b6b6b6 !important;
}

.top-nav-bar{
  text-align: center;
  background: $primary-background;
  justify-content: space-around;
}

.nav-item{
  color: $dull-text-color !important;
}

.inactive:hover{
  color:$text-color !important;
}
.active{
    background: $primary-background !important;
    color:$active-blue  !important;
    border-bottom: 2px solid $active-blue ;
}

::v-deep{
  .vjs-control-bar{
    display: flex !important;
    opacity:1 !important;
  }

  .theme--light.v-text-field--solo>.v-input__control>.v-input__slot {
          background: $primary-background;
          border-bottom: $border-color;
      }
  .theme--light.v-text-field--filled:not(.v-input--is-focused):not(.v-input--has-state)>.v-input__control>.v-input__slot:hover {
      background:$primary-background;
  }
  .theme--light.v-chip {
      border-color:#3a3a3a !important;
      color:$text-color;
  }

  .theme--light.v-chip:not(.v-chip--active) {
      background: $primary-background;
  }

  .v-list-item--link:before{
    background-color:$primary-background;
  }
  .vjs_video_3-dimensions, .video-js{
      height:350px !important;
      width:100% !important;
  }
  .video-js{
      height:350px !important;
      width:100% !important;
  }

  .multiselect{
        width:100% !important;
        margin: 3px 0px !important;
  }
  .multiselect__content-wrapper{
    display:none;
  }
  .multiselect__tag {
      background-color: $primary-background !important;
    border: $border-color;
      border-radius: 13px;
    }
    .profile-comm-style{
        .multiselect__tags{
            background: $primary-background !important;
            border: $border-color !important;
            padding-top: 0px;
        }
        .multiselect__tags:hover{
            border:1px solid $icon-hover
        }
        .multiselect__single{
            padding-top:7px !important;
        }
    }
    .multiselect__option--highlight {
        background: $bg-color-on-hover !important;
    }
    .multiselect__content {
        background: $secondary-background-color !important;
    }
    .multiselect__input{
      height:30px !important;
    }
    .multiselect__input, .multiselect__single {
        background: transparent !important;
        color:$text-color;
    }
    .multiselect__input:focus{
      box-shadow: none !important;
    }
    .multiselect__tag-icon{
       color:$text-color !important;
    }
    .multiselect__tag-icon:focus, .multiselect__tag-icon:hover {
        background: $bg-color-on-hover !important;
        color: $text-color !important;
    }
    .multiselect__tag-icon:after{
       color:$icon-hover !important;
       font-size: 23px;
    }

    .multiselect__tag-icon{
      visibility:hidden;
    }

    .multiselect__tag:hover .multiselect__tag-icon{
      visibility:visible;
    }

    .multiselect *{
        font-size: $input-field-and-label-font-size !important;
        font-family: "Roboto", Arial, sans-serif !important;
    }
    .multiselect__placeholder {
      padding-top: 6px;
     }
    .multiselect{
      color:$text-color !important;
      font-size: $input-field-and-label-font-size !important;
      width:28%;
      min-height: 38px;
    }
    .multiselect__single{
      padding-top:0px !important;
    }
    .multiselect__option--selected{
        background: $bg-color-on-hover !important;
        color: $text-color;
    }
    .multiselect__content-wrapper{
        border: 1px solid $bg-color-on-hover !important;
        position: absolute;
        display: block;
        background: $text-color;
        width: 100% !important;
        max-height: 240px;
        overflow: auto;
        border: 1px solid $text-color;
        border-top: none;
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
        z-index: 50;
        -webkit-overflow-scrolling: touch;
    }
    .multiselect__select,.multiselect__current,.multiselect__option{
        line-height: 12px !important;
    }
    .multiselect--above .multiselect__content-wrapper{
       background: $secondary-background-color !important;
    }
}
.secondary-btn-style:hover{
  text-decoration: underline;
}

.selected-thumbnail-display{
    width: 100%;
    display: inline-block;
    img{
        height:100%;
        height: 100%;
        object-fit: contain;
        width: 100%;
    }
    svg{
        float: inline-end;
        margin-top:5px;
    }
}


.audio-player{
    position: absolute;
    bottom: 0px;
    width: 100%;
    height: 26px;
    inset-inline-start:0px;
}


.close-icon:hover{
  background: #373737;
  border-radius: 20px;
}

input:focus,select:focus,textarea:focus,.multiselect__input:focus,.mx-input:focus{
    outline: none;
    --saf-0: rgba(var(--sk_highlight,18,100,163),1);
    box-shadow: 0 0 0 1px var(--saf-0),0 0 0 5px #00254E;
    border-radius: 4px;
    border-color: transparent;
    -webkit-appearance: none;
}

.outer {
  display: table;
  position: absolute;
  top: 0;
  inset-inline-start: 0;
  height: 100%;
  width: 100%;
}

.middle {
  display: table-cell;
  vertical-align: middle;
}

.inner {
  margin-inline-start: auto;
  margin-inline-end: auto;
  width: 22%;
  height: 138px;
  margin-bottom:10%;
  /* Whatever width you want */
  img{
    height:100%;
  }
  p{
    text-align: center;
    color: #666;
    font-size: 18px;
  }
}

.primary-btn-style {
  margin-top: 1%;
  bottom: 8px;
  inset-inline-end: 0%;
  height:50px;
  width:100%;
  z-index:9;
  padding:0px;
  justify-content: end;
  button {
    height: 38px !important;
    width: 70px;
    font-size:14px;
    margin-top:7px;
  }
  .btn-outline-secondary{
    float:inline-end;
  }
  .btn-outline-primary{
    margin-inline-end:15px;
  }
}

.common-input-field{
    margin-inline-start: 3%;
    display: inline-block;
    width: 96%;
    justify-content: space-between;
    display: inline-block;
    padding: 9px;
    border-radius: 4px;
    background: $primary-background;
    border: $secondary-border-color !important;
    label{
        width: 30%;
        color: $dull-text-color;
        word-break: break-word;
    }
    input{
        flex:1;
    }
}

.input-text-field{
    height: 38px;
    width: 100% !important;
    padding-inline-start: 2%;
    padding-inline-end:2%;
}

.add-border{
    border: $border-color;
}

.social-media{
        border: $border-color;
        border-radius: 21px;
        padding-inline-end: 8px;
        margin-inline-start: 5px;
    }
.social-media:hover{
  opacity: 1 !important;
}

.view-tags-data {
  font-size:12px!important;
  height: 30px!important;
  display: inline-flex!important;
  margin: 2px;
  border: 1px solid $tags-border-color;
  border-radius: 15px!important;
  min-width: 50px!important;
  padding: 0!important;
  text-align: center;
  width: fit-content !important;
  padding-inline-start: 1px!important;
  justify-content: center;
  padding-top: 4px!important;
  background: $tags-background-color;
  padding: 5px 11px !important;
  span {
    padding: 0px 8px !important;
    margin-inline-start: 0px !important;
    font-size:12px !important;
    border-radius: 15px !important;
    position: relative !important;
    top: 1px !important;
  }
}

.add-tags{
  background: $primary-background !important;
  color:$add-button-text-color;
  border: 1px solid $add-button-border-color !important;
  margin-inline-start: 5px !important;
  svg{
    margin-top: -4px;
  }
}

.add-tags:hover{
  color:$add-button-text-color-hover;
  border: 1px solid $add-button-border-on-hover;
}

.heightSet{
  overflow:auto;
    padding-top:15px;
    .thumbanils-display{
      height:160px;
      display:inline-flex;
      width: 100%;
      justify-content: center;
      .thumbnail-comm-wrapper{
        padding: 3px;
        .generated-thumbails,.custom-thumbanil{
            height: 120px;
            width: 180px;
            border: 1px solid #161616;
            background: #110e13;
            position:relative;
            padding:3px;
            position: relative;
          }
        .custom-thumbanil{
          position:relative;
          border: 3px dotted #1a1a1a;
        }
        .comm-thumbnail-btn-div{
          display: inline-flex;
          justify-content: center;
          width: 100%;
          margin-top: 2px;
          .comm-thumbnail-btn{
            height: 30px;
            padding: 5px;
            width: 90%;
            margin: 0px !important;
            display: inline-block;
          }
          .comm-thumbnail-btn:disabled{
            color: #eee;
            background-color: transparent;
            border: $tags-border-color;
          }
        }
      }  
    }
}

.clear-captured-image{
  position: absolute;
  inset-inline-end: 4px;
  top: 10px;
  width: 22px;
  background: #00000099;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  height: 22px;
  svg{
    margin:0px !important;
  }
}


.filter-label{
  position: relative;
  bottom: 4px;
  padding-inline-start:8px;
  width:unset !important;
  margin-bottom:0px !important;
}

input[type="radio"] {
  /* background-color only for content */
  background-color:$primary-background !important;
}

/* appearance for checked radiobutton */
input[type="radio"]:checked {
  background-color: $active-blue !important;
  //background-image: linear-gradient(to bottom, #5294ce, #3176b3) !important;
  background: radial-gradient(circle, $active-blue 40%, $primary-background 49%, $primary-background 100%) !important;
  border: 1px solid $active-blue !important;
}

input[type="radio"] {
  outline: none !important;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  display: inline-block;
  padding: 4px;
  border-radius: 50% !important;
  width: 20px;
  height: 20px;
  border: 1px solid #4a4a4a !important;
}


::placeholder {
  color: $dull-text-color !important;
}

.click-to-copy-button:hover{
  text-decoration: underline;
}

.user-name-or-image{
  height: 30px;
  width: 30px;
  border: $border-color;
  border-radius: 10px;
  text-align: center;
  line-height: 28px;
  text-transform: uppercase;
  margin-top: 3px;
  top:4px !important;
  position:relative
}

.logo-display{
  position: absolute;
  inset-inline-end:0px;
  bottom:2px;
}

.user-name{
  margin-inline-end: 10px;
  position: relative;
  bottom: 7px;
}

.view-tags {
  font-size:10px!important;
  display: inline-flex!important;
  margin: 2px!important;
  border: 1px solid $tags-border-color!important;
  border-radius: 10px!important;
  min-width: 50px!important;
  padding: 0!important;
  text-align: center;
  width: 45% !important;
  justify-content: center;
  align-items: center;
  background: $bg-color-on-hover;
  span {
    padding: 0px 8px !important;
    margin-inline-start: 0px !important;
    font-size:12px !important;
    border-radius: 15px !important;
    color: #fff;
    width:77%;
    text-align:start;
  }
}

.logo-display{
  position: absolute;
  inset-inline-end: -1px;
  bottom: -5px;
}

.logo-display{
  color: #999;
  background: #1a1a1ab3;
  min-width: 23px;
  width: auto;
  inset-inline-end: -1px;
  bottom: -2px;
  border-bottom-right-radius: 4px;
  border-top-left-radius: 4px;
  display: flex;
  justify-content: center;
  position:absolute;  
}

.user-name-or-image-in-profile{
  height: 60px;
  //width: 60px;
  border: $border-color;
  border-radius: 10px;
  text-align: center;
  line-height: 56px;
  text-transform: uppercase;
  margin: 0 auto;
  font-size: 30px;
  position: relative;
  flex-wrap:wrap;
}

</style>
